import React, {Component} from 'react';
import { getActivity } from "../resources/utils";
import { motion } from "framer-motion";

import styles from './ActivityList.module.scss';

import Loading from "./Loading";

class ActivityList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
    };
  }

  async componentDidMount() {
    if(this.props.id) {
      this.setState({ data: await getActivity(this.props.id)});
    }
  }

  async componentDidUpdate(prevProps) {
    if(this.props.id !== prevProps.id) {
      this.setState({ data: null }, async() => {
        this.setState({ data: await getActivity(this.props.id)});
      });
    }
  }

  render() {
    const { data } = this.state;
    // console.log(data);
    const { id } = this.props;
    if(!data) {
      return (
        <div key={id}>
          <Loading />
        </div>
      )
    }
    return (
      <div className={styles.cards} key={id}>
      {
        [ ...data ].reverse().map(x => {
          return (
            <motion.div className={styles.card} initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} key={x.created} transition={{
              y: { type: "spring", stiffness: 300, damping: 30 },
              opacity: { duration: 0.2 }
            }}>
              <strong>{x.reason}</strong>
              <span><strong>Event date: </strong>{new Date(x.created).toLocaleTimeString([], {year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute:'2-digit'})}</span>
              <span><strong>Points change: </strong>{x.points}</span>
              {
                (x.details && x.details.length !== 0) &&
                <div>
                  <strong>Details:</strong>
                  {
                    x.details.map((z,i) => <span key={i}>{z}</span>)
                  }
                </div>
              }
            </motion.div>
          )
        })
      }
      </div>
    );
  }
}

export default ActivityList;
